import React, { useState } from 'react'
import Slider from 'react-slick'
import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import Navbar from '../components/navbar'
import Mark from '../components/mark'
import Card from '../components/card'
import Accordion from '../components/accordion'
import Includes from '../components/includes'
import Excludes from '../components/excludes'
import Review from '../components/review'
import Article from '../components/article'
import FAQ from '../components/faq'
import ContactModal from '../components/contact-modal'
import Footer from '../components/footer'
import './home.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Home = (props) => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="home-container1">
      <Helmet>
        <title>Social Media Recruiting Agentur Berlin | track by track GmbH - Fachkräfte über LinkedIn, Instagram & TikTok</title>
        <meta name="description" content="Als spezialisierte Social Media Recruiting Agentur in Berlin finden wir qualifizierte Fachkräfte für Ihr Unternehmen. ✓ LinkedIn Recruiting ✓ Instagram Jobs ✓ TikTok Karriere-Content ✓ Active Sourcing. Jetzt kostenlose Beratung!" />
        <meta name="keywords" content="social media recruiting agentur, social recruiting, linkedin recruiting, instagram recruiting, tiktok recruiting, fachkräftegewinnung, personalmarketing, employer branding, active sourcing, recruiting agentur berlin" />
        <link rel="canonical" href="https://social-media-recruiting-agentur.com/" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://social-media-recruiting-agentur.com/" />
        <meta property="og:title" content="Social Media Recruiting Agentur | Fachkräfte digital gewinnen" />
        <meta property="og:description" content="Wir sind Ihre Social Media Recruiting Agentur für qualifizierte Bewerber über LinkedIn, Instagram & TikTok. Moderne Personalgewinnung mit messbaren Ergebnissen." />
        <meta property="og:image" content="https://social-media-recruiting-agentur.com/social-media-recruiting-agentur-hero.png" />
        <meta property="og:locale" content="de_DE" />
        <meta property="og:site_name" content="track by track GmbH - Social Media Recruiting" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Social Media Recruiting Agentur | track by track GmbH" />
        <meta name="twitter:description" content="Fachkräfte über Social Media gewinnen. LinkedIn, Instagram & TikTok Recruiting mit Erfolgsgarantie." />
        <meta name="twitter:image" content="https://social-media-recruiting-agentur.com/social-media-recruiting-agentur-hero.png" />
      </Helmet>
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>
      <section className="home-section10">
        <div className="home-hero">
          <div className="home-content1">
            <main className="home-main1">
              <header className="home-header10" >
                <h1 className="home-heading10">
                  Social Recruiting Agentur für erfolgreiches Social Media Recruiting und Mitarbeitergewinnung
                </h1>
                <span className="home-caption1">
                  Als spezialisierte Social Recruiting Agentur aus Berlin helfen wir Ihnen beim Einstieg ins professionelle Social Media Recruiting. Nutzen Sie die Kraft von Social Media für erfolgreiches Employer Branding, gezieltes Personalmarketing und die Gewinnung qualifizierter Bewerber über jeden relevanten Kanal. Lassen Sie sich von unserer Expertise im Social Media Recruiting überzeugen und entdecken Sie, wie Social Recruiting Ihre Bewerbungen revolutioniert – besonders im Mittelstand.
                </span>
              </header>
              <div className="home-buttons1" style={{ visibility: 'hidden' }}>
                <div className="home-get-started1 button" onClick={() => openContactModal('Kostenlose Beratung')} style={{ cursor: 'pointer' }}>
                  <span className="home-text10">Kostenlose Beratung</span>
                </div>
                <div className="home-get-started2 button">
                  <span className="home-text11">Mehr erfahren</span>
                </div>
              </div>
            </main>
            <div className="home-highlight">
              <label className="home-caption2" style={{ marginBottom: '20px', display: 'block' }}>
                Social Media Recruiting
              </label>
              <div className="home-client-logos" style={{ 
                maxWidth: '600px', 
                margin: '0 auto',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                padding: '24px 12px'
              }}>
                <Slider
                  dots={false}
                  infinite={true}
                  autoplay={true}
                  autoplaySpeed={2000}
                  speed={800}
                  slidesToShow={3}
                  slidesToScroll={1}
                  arrows={false}
                  responsive={[
                    {
                      breakpoint: 767,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                    }
                  ]}
                >
                  <div style={{ padding: '0 15px' }}>
                    <img
                      src="/rewe.png"
                      alt="REWE"
                      style={{ 
                        width: '100%', 
                        height: '60px', 
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                        opacity: 0.9
                      }}
                    />
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    <img
                      src="/oxford.png"
                      alt="Oxford"
                      style={{ 
                        width: '100%', 
                        height: '60px', 
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                        opacity: 0.9
                      }}
                    />
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    <img
                      src="/fleurop.png"
                      alt="Fleurop"
                      style={{ 
                        width: '100%', 
                        height: '60px', 
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                        opacity: 0.9
                      }}
                    />
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    <img
                      src="/vattenfall.png"
                      alt="Vattenfall"
                      style={{ 
                        width: '100%', 
                        height: '60px', 
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                        opacity: 0.9
                      }}
                    />
                  </div>
                  <div style={{ padding: '0 15px' }}>
                    <img
                      src="/casio.png"
                      alt="Casio"
                      style={{ 
                        width: '100%', 
                        height: '60px', 
                        objectFit: 'contain',
                        filter: 'brightness(0) invert(1)',
                        opacity: 0.9
                      }}
                    />
                  </div>
                </Slider>
              </div>
            </div>
          </div>
          <div className="home-image13">
            <img
              alt="Social Media Recruiting"
              src="/social-media-recruiting-agentur-hero.png"
              className="home-image14"
            />
          </div>
          <div className="home-image15">
            <img
              alt="Social Recruiting Strategie"
              src="/social-media-recruiting-agentur-hero.png"
              className="home-image16"
            />
          </div>
        </div>
      </section>
      <section className="home-section11" style={{ marginTop: '80px' }}>
        <h2 className="home-text12">
          Warum Social Recruiting für Ihr Unternehmen unverzichtbar ist
        </h2>
        <div className="home-features1">
          <header className="feature feature-active home-feature1">
            <h3 className="home-text13">Gezieltes Social Recruiting</h3>
            <p className="home-text14">Erreichen Sie Ihre Zielgruppe präzise über Social Media</p>
          </header>
          <header className="feature home-feature2">
            <h3 className="home-text15">Employer Branding</h3>
            <p className="home-text16">Stärken Sie Ihre Arbeitgebermarke nachhaltig</p>
          </header>
          <header className="feature home-feature3">
            <h3 className="home-text17">Qualifizierte Bewerber</h3>
            <p className="home-text18">Gewinnen Sie passende Kandidaten effizient</p>
          </header>
        </div>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Was ist Social Recruiting und warum ist Social Media Recruiting so erfolgreich?
              </h2>
              <p className="home-paragraph1">
                <span>
                  Social Recruiting bezeichnet die gezielte Nutzung von Social Media Plattformen für die Mitarbeitergewinnung. Im Gegensatz zu traditionellen Stellenanzeigen ermöglicht Social Media Recruiting eine direkte und authentische Ansprache potenzieller Bewerber dort, wo sie ihre Zeit verbringen. Eine Social Recruiting Agentur unterstützt Unternehmen dabei, diese digitalen Kanäle professionell zu nutzen und qualifizierte Fachkräfte zu erreichen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Fachkräftemangel betrifft nahezu jede Branche – besonders den Mittelstand. Social Recruiting hilft Unternehmen, sich von der Konkurrenz abzuheben und passive Kandidaten anzusprechen, die nicht aktiv auf Job-Suche sind. Durch gezieltes Personalmarketing über soziale Netzwerke wie LinkedIn, Facebook und Instagram können Sie Ihre Arbeitgebermarke stärken und authentisch kommunizieren, was Ihr Unternehmen auszeichnet.
                </span>
                <br></br>
                <span>
                  Eine professionelle Social Media Recruiting Agentur entwickelt massgeschneiderte Social Recruiting Kampagnen, die nicht nur Reichweite erzeugen, sondern qualifizierte Bewerbungen generieren. Dabei werden moderne Recruiting-Techniken mit datengetriebenem Marketing kombiniert, um die richtigen Talente zur richtigen Zeit zu erreichen. Das Potenzial von Social Media liegt in der Möglichkeit, Stellenanzeigen gezielt an Ihre Zielgruppe auszuspielen und durch ansprechendes Employer Branding zu überzeugen.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Jetzt Social Recruiting starten')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Jetzt Social Recruiting starten →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Media Recruiting Strategie"
              src="/social-media-recruiting-agentur-zusammenwirken.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>
      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Wie funktioniert erfolgreiches Social Media Recruiting?</h2>
          <span className="home-text26">
            Als spezialisierte Social Recruiting Agentur begleiten wir Sie Schritt für Schritt beim Aufbau Ihrer erfolgreichen Social Media Recruiting-Strategie. Von der Analyse über die Kampagne bis zur Optimierung.
          </span>
        </header>
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Social Recruiting Prozess"
              src="/social-media-recruiting-agentur-funktion.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Der digitale Recruiting Prozess</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Von der Strategie zur qualifizierten Bewerbung: So funktioniert modernes Recruiting
                </h2>
                <p className="section-description">
                  Erfolgreiches Social Recruiting beginnt mit einer durchdachten Strategie. Als erfahrene Agentur analysieren wir zunächst Ihre Zielgruppe, Ihre Branche und Ihre spezifischen Anforderungen. Welche Plattform eignet sich am besten? LinkedIn für Fachkräfte im B2B-Bereich? Facebook und Instagram für jüngere Zielgruppen? Oder eine Kombination mehrerer Kanäle?
                  
                  Im nächsten Schritt entwickeln wir eine Social Media Recruiting Strategie, die zu Ihrem Unternehmen passt. Dabei berücksichtigen wir Ihr Employer Branding, Ihre Arbeitgebermarke und erstellen Inhalte, die authentisch sind und Bewerber ansprechen. Unsere Social Recruiting Maßnahmen umfassen sowohl organische Beiträge als auch bezahlte Recruiting Ads, um maximale Sichtbarkeit zu erzielen und passive Kandidaten zu aktivieren.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Strategie-Gespräch buchen')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Strategie-Gespräch buchen</span>
            </div>
          </div>
        </section>
        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Recruiting Kampagne"
              src="/social-media-recruiting-agentur-ads.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Ihre Social Recruiting Kampagne
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Mit gezielten Social Media Kampagnen zu mehr qualifizierten Bewerbungen
                  </h2>
                  <p className="section-description">
                    Eine Social Recruiting Kampagne ist mehr als nur eine Stellenanzeige auf Social Media. Es geht darum, potenzielle Bewerber auf ihrer Customer Journey zu begleiten – vom ersten Kontakt bis zur Bewerbung. Dabei nutzen wir verschiedene Content-Formate: Videos, die Ihre Unternehmenskultur zeigen, Mitarbeiter-Testimonials, Behind-the-Scenes-Einblicke und natürlich ansprechend gestaltete Stellenanzeigen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Gezielte Ansprache Ihrer Wunschkandidaten über soziale Netzwerke"></Mark>
                  <Mark label="Kontinuierliche Optimierung der Kampagne für bessere Ergebnisse"></Mark>
                  <Mark label="Transparentes Reporting und Erfolgsmessung beim digitalen Recruiting"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Kampagne starten')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Kampagne starten</span>
            </div>
          </div>
        </section>
      </section>
      <section className="home-section15">
        <header className="home-header13">
          <header className="home-left1">
            <span className="section-head">Unsere Expertise</span>
            <h2 className="section-heading">
              <span>Warum Social Recruiting mit unserer Agentur</span>
              <br></br>
              <span>der Schlüssel zu Ihrem Erfolg ist</span>
            </h2>
          </header>
          <div className="home-right1">
            <p className="home-paragraph4 section-description">
              Als spezialisierte Social Media Recruiting Agentur aus Berlin bringen wir die perfekte Kombination aus Recruiting-Expertise und Social-Media-Know-how mit. Wir verstehen beide Welten und wissen, wie man sie erfolgreich verbindet.
            </p>
          </div>
        </header>
        <main className="home-cards1">
          <Card 
            icon="/Icons/group%201316-200w.png"
            header="LinkedIn Recruiting"
            description="Nutzen Sie LinkedIn gezielt für die Ansprache von Fachkräften. Plattformen wie LinkedIn sind ideal für B2B-Recruiting und die Suche nach hochqualifizierten Talenten."
            rootClassName="cardroot-class-name"
          ></Card>
          <Card
            icon="/Icons/group%201314-200h.png"
            header="Facebook & Instagram"
            description="Erreichen Sie eine breitere Zielgruppe über Facebook und Instagram. Social Media Kampagnen auf diesen Plattformen eignen sich perfekt für Active Sourcing und Employer Branding."
            rootClassName="cardroot-class-name1"
          ></Card>
          <Card
            icon="/Icons/group%201317-200h.png"
            header="Social Networks Strategie"
            description="Wir entwickeln plattformübergreifende Strategien für soziale Netzwerke, um Ihre offene Stellen optimal zu besetzen und passende Kandidaten anzusprechen."
            rootClassName="cardroot-class-name2"
          ></Card>
        </main>
      </section>
      <section className="home-section17">
        <div className="home-note4">
          <div className="home-image23">
            <img
              alt="Social Media Recruiting Tipps"
              src="/social-media-recruiting-agentur-wichtig.png"
              className="home-image24"
            />
          </div>
          <div className="home-content5">
            <div className="home-caption5">
              <span className="section-head">Best Practices</span>
            </div>
            <div className="home-heading17">
              <div className="home-header14">
                <h2 className="section-heading">
                  Die wichtigsten Tipps für erfolgreiches Social Recruiting
                </h2>
              </div>
              <Accordion 
                text="Wie finde ich die richtige Agentur für mein Social Recruiting?"
                text1="Die Zusammenarbeit mit einer Social Recruiting Agentur sollte auf Vertrauen und Expertise basieren. Achten Sie darauf, dass die Agentur Erfahrung in Ihrer Branche hat, nachweisbare Erfolge vorweisen kann und eine datengetriebene Arbeitsweise pflegt. Eine gute Social Media Recruiting Agentur analysiert zunächst Ihre Situation, bevor sie Lösungen vorschlägt."
                text2="Warum ist Social Media Recruiting effektiver als traditionelle Methoden?"
                text3="Social Media Recruiting ermöglicht es Ihnen, auch passive Kandidaten zu erreichen – also Fachkräfte, die nicht aktiv auf Job-Suche sind, aber offen für neue Chancen. Zudem können Sie durch Social Media Ihre Arbeitgebermarke aufbauen und authentisch zeigen, was Ihr Unternehmen auszeichnet. Die Kosten pro qualifizierter Bewerbung sind oft niedriger als bei traditionellen Kanälen."
                text4="Welche Plattform eignet sich am besten für meine Stellenanzeigen?"
                text5="Die Wahl der Plattform hängt von Ihrer Zielgruppe ab. LinkedIn eignet sich hervorragend für Fach- und Führungskräfte, während Facebook und Instagram besonders effektiv sind, wenn Sie jüngere Talente oder Kandidaten aus dem gewerblichen Bereich ansprechen möchten. Eine Social Recruiting Agentur kann Sie beraten, welche Kanäle für Ihre spezifischen Anforderungen am besten geeignet sind."
                rootClassName="accordionroot-class-name"
              ></Accordion>
            </div>
          </div>
        </div>
      </section>
      <section className="home-section19">
        <div className="home-cube1">
          <div className="home-top1 side"></div>
          <div className="home-front1 side"></div>
          <div className="home-left2 side"></div>
        </div>
        <main className="home-banner">
          <div className="home-header15">
            <h2 className="section-heading">
              Starten Sie jetzt mit Social Recruiting und gewinnen Sie die besten Talente
            </h2>
            <p className="home-description1 section-description">
              Nutzen Sie Social Media für Ihre Mitarbeitergewinnung und bekämpfen Sie den Fachkräftemangel erfolgreich!
            </p>
          </div>
          <div className="home-buttons2">
            <div className="home-get-started5 button" onClick={() => openContactModal('Kostenlose Erstberatung')} style={{ cursor: 'pointer' }}>
              <span className="home-text32">Kostenlose Erstberatung</span>
            </div>
          </div>
        </main>
      </section>
      <section className="home-section20">
        <div className="home-cube2">
          <div className="home-top2 side"></div>
          <div className="home-front2 side"></div>
          <div className="home-left3 side"></div>
        </div>
        <main className="home-pricing1">
          <header className="home-header16" style={{ textAlign: 'center', maxWidth: '800px', margin: '0 auto' }}>
            <header className="home-left4">
              <span className="section-head">Was kostet Social Recruiting?</span>
              <h2 className="section-heading home-heading20">
                Transparente Preise für Social Media Recruiting
              </h2>
            </header>
            <div className="home-right2">
              <p className="home-paragraph5 section-description">
                Die Investition in Social Recruiting zahlt sich aus. Im Vergleich zu traditionellen Recruiting-Methoden sparen Sie Zeit und Kosten, während Sie gleichzeitig mehr qualifizierte Bewerber erreichen. Unsere Social Recruiting Agentur bietet flexible Pakete für jeden Bedarf.
              </p>
            </div>
          </header>
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <div className="home-get-started5 button" onClick={() => openContactModal('Preise anfragen')} style={{ cursor: 'pointer', display: 'inline-block' }}>
              <span>Jetzt Preise anfragen</span>
            </div>
          </div>
        </main>
      </section>
      <section className="home-section22">
        <header className="home-header20">
          <header className="home-left5">
            <span className="section-head">Erfolgsgeschichten</span>
            <h2 className="home-heading24 section-heading">
              Was Unternehmen über unsere Social Recruiting Agentur sagen
            </h2>
          </header>
          <div className="home-right3">
            <p className="home-paragraph6 section-description">
              Unsere Kunden aus dem Mittelstand und verschiedensten Branchen vertrauen auf unsere Expertise im Social Media Recruiting. Lesen Sie, wie wir ihnen geholfen haben, qualifizierte Fachkräfte zu gewinnen.
            </p>
          </div>
        </header>
        <main className="home-cards2" style={{maxWidth: '1200px', margin: '0 auto', padding: '0 24px'}}>
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={3}
            slidesToScroll={1}
            responsive={[
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 1.5,
                  slidesToScroll: 1,
                  centerMode: true,
                  centerPadding: '20px'
                }
              }
            ]}
          >
            <div style={{padding: '0 12px'}}>
              <Review
                quote="Mit famefact haben wir täglich eine wertvolle Unterstützung und können so unsere Social Media Kanäle kontinuierlich ausbauen."
                author="Britta"
                position="Senior Brand Manager Casio"
                avatarSrc="/britta.webp"
                rootClassName="reviewroot-class-name"
              />
            </div>
            <div style={{padding: '0 12px'}}>
              <Review
                quote="Durch das passende Targeting konnten wir in den letzten Jahren viele offene Stellen besetzen."
                author="Jenny"
                position="Social Media Captrain"
                avatarSrc="/jenny.webp"
                rootClassName="reviewroot-class-name"
              />
            </div>
            <div style={{padding: '0 12px'}}>
              <Review
                quote="Für mich hieß es im täglichen Ablauf einen verlässlichen Partner an meiner Seite zu wissen"
                author="Sylke"
                position="AOK Unternehmenspolitik Stabsstelle"
                avatarSrc="/sylke.webp"
                rootClassName="reviewroot-class-name"
              />
            </div>
            <div style={{padding: '0 12px'}}>
              <Review
                quote="Besonders gefällt uns die flexible Kommunikation, durch die wir spontan agieren können."
                author="Anna"
                position="Personalmarketing Asphericon"
                avatarSrc="/anna.webp"
                rootClassName="reviewroot-class-name"
              />
            </div>
            <div style={{padding: '0 12px'}}>
              <Review
                quote="Sehr gute Ergebnisse, toll aufbereitet und absolut zuverlässig"
                author="Michael"
                position="Senior Vice President Bertelsmann"
                avatarSrc="/michael.webp"
                rootClassName="reviewroot-class-name"
              />
            </div>
          </Slider>
        </main>
      </section>
      <section className="home-section24">
        <header className="home-header21">
          <p className="press-label">Presseberichte</p>
        </header>
        <main className="home-press-carousel">
          <Slider
            dots={false}
            infinite={true}
            autoplay={true}
            autoplaySpeed={2000}
            speed={500}
            slidesToShow={5}
            slidesToScroll={1}
            arrows={false}
            responsive={[
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]}
          >
            <div className="press-logo-wrapper">
              <img src="/internetworldbusiness.webp" alt="Internet World Business" className="press-logo-img" />
            </div>
            <div className="press-logo-wrapper">
              <img src="/berliner-wirtschaft.webp" alt="Berliner Wirtschaft" className="press-logo-img" />
            </div>
            <div className="press-logo-wrapper">
              <img src="/spiegel.webp" alt="Spiegel" className="press-logo-img" />
            </div>
            <div className="press-logo-wrapper">
              <img src="/handelsblatt.webp" alt="Handelsblatt" className="press-logo-img" />
            </div>
            <div className="press-logo-wrapper">
              <img src="/zeit-online.webp" alt="Zeit Online" className="press-logo-img" />
            </div>
            <div className="press-logo-wrapper">
              <img src="/lto.webp" alt="Legal Tribune Online" className="press-logo-img" />
            </div>
          </Slider>
        </main>
      </section>
      <section className="home-section11">
        <h2 className="home-text12">
          Social Recruiting und Employer Branding: Die perfekte Kombination für erfolgreiche Mitarbeitergewinnung
        </h2>
        <div style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 24px' }}>
          <video 
            controls
            autoPlay 
            muted
            loop
            playsInline
            style={{ 
              width: '100%', 
              height: 'auto',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer'
            }}
          >
            <source src="/social-media-recruiting-agentur.mp4" type="video/mp4" />
            Ihr Browser unterstützt das Video-Tag nicht.
          </video>
        </div>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11" style={{ marginTop: '100px' }}>
                Wie Social Recruiting und Employer Branding zusammenwirken
              </h2>
              <p className="home-paragraph1">
                <span>
                  Erfolgreiches Social Recruiting beginnt mit einer starken Arbeitgebermarke. Employer Branding ist die Grundlage, um auf Social Media authentisch und überzeugend zu kommunizieren. Eine Social Recruiting Agentur unterstützt Sie dabei, Ihre Arbeitgebermarke zu entwickeln und über Social Media Kanäle zu stärken. Dabei geht es nicht nur um schöne Bilder und Hochglanzvideos, sondern um authentische Einblicke in Ihr Unternehmen, Ihre Unternehmenskultur und die Vorteile, die Sie als Arbeitgeber bieten.
                </span>
                <br></br>
                <br></br>
                <span>
                  Social Media Recruiting funktioniert am besten, wenn es Teil einer ganzheitlichen Employer-Branding-Strategie ist. Potenzielle Bewerber informieren sich heute online über Unternehmen, bevor sie sich bewerben. Ihre Präsenz auf sozialen Netzwerken, die Inhalte, die Sie teilen, und die Art, wie Sie mit Ihrer Community interagieren, prägen die Wahrnehmung Ihrer Arbeitgebermarke. Eine professionelle Social Media Recruiting Agentur hilft Ihnen, diese Touchpoints gezielt zu gestalten und eine kohärente Botschaft zu vermitteln.
                </span>
                <br></br>
                <span>
                  Beim Social Recruiting geht es darum, qualifizierte Kandidaten nicht nur zu erreichen, sondern sie auch von Ihrem Unternehmen zu überzeugen. Durch gezieltes Personalmarketing auf Social Media können Sie Ihre Unternehmenskultur zeigen, Mitarbeiter-Testimonials teilen und transparent kommunizieren, was Ihr Unternehmen auszeichnet. Social Recruiting Kampagnen, die auf einer starken Arbeitgebermarke aufbauen, generieren nicht nur mehr Bewerbungen, sondern vor allem qualifizierte Bewerbungen von Kandidaten, die wirklich zu Ihrem Unternehmen passen.
                </span>
                <br></br>
                <span>
                  Eine spezialisierte Social Recruiting Agentur entwickelt für Sie eine integrierte Strategie, die Employer Branding und Social Media Recruiting verbindet. Dabei werden Ihre Alleinstellungsmerkmale als Arbeitgeber herausgearbeitet, eine konsistente visuelle und sprachliche Identität entwickelt und Content-Formate erstellt, die Ihre Zielgruppe ansprechen. Von Behind-the-Scenes-Videos über Mitarbeiter-Interviews bis hin zu authentischen Einblicken in den Arbeitsalltag – die Möglichkeiten sind vielfältig.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Employer Branding Beratung')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Employer Branding Beratung anfragen →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Employer Branding Strategie"
              src="/social-media-recruiting-agentur-erfolg.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>
      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Die wichtigsten Kanäle für erfolgreiches Social Recruiting im Detail</h2>
          <span className="home-text26">
            Als Social Media Recruiting Agentur kennen wir die Besonderheiten jeder Plattform und wissen, wie Sie diese optimal für Ihre Mitarbeitergewinnung nutzen können.
          </span>
        </header>
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="LinkedIn für Recruiting"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">LinkedIn als Recruiting-Kanal</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  LinkedIn: Die Plattform für qualifizierte Fachkräfte und B2B-Recruiting
                </h2>
                <p className="section-description">
                  LinkedIn ist die führende Plattform für professionelles Networking und eignet sich hervorragend für Social Recruiting im B2B-Bereich. Plattformen wie LinkedIn ermöglichen es, gezielt Fachkräfte mit spezifischen Qualifikationen anzusprechen. Mit über 800 Millionen Nutzern weltweit und einem hohen Anteil an Fach- und Führungskräften ist LinkedIn ideal für die Ansprache anspruchsvoller Zielgruppen.
                  
                  Eine Social Recruiting Agentur nutzt LinkedIn für verschiedene Recruiting-Maßnahmen: Von organischen Unternehmensbeiträgen über LinkedIn-Artikel bis hin zu gezielten Recruiting Ads. Besonders effektiv ist Active Sourcing auf LinkedIn – die direkte Ansprache potenzieller Kandidaten durch Recruiter. Dabei können Sie nach Jobtiteln, Fähigkeiten, Branchen und vielen weiteren Kriterien filtern, um passende Kandidaten zu finden.
                  
                  LinkedIn bietet auch umfangreiche Möglichkeiten für Employer Branding: Durch eine professionell gestaltete Unternehmensseite, regelmäßige Posts zu Unternehmenskultur und Werten sowie Mitarbeiter-Testimonials können Sie Ihre Arbeitgebermarke stärken. Stellenanzeigen auf LinkedIn erreichen eine hochqualifizierte Zielgruppe und können durch detailliertes Targeting noch präziser ausgespielt werden.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('LinkedIn-Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">LinkedIn-Strategie entwickeln</span>
            </div>
          </div>
        </section>
        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Facebook Instagram Recruiting"
              src="/social-media-recruiting-agentur-kampagne.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Facebook und Instagram
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Facebook und Instagram: Reichweite und Authentizität für Ihr Recruiting
                  </h2>
                  <p className="section-description">
                    Facebook und Instagram sind mit über 3 Milliarden aktiven Nutzern die reichweitenstärksten Social Media Plattformen. Für Social Recruiting bieten diese Kanäle enorme Möglichkeiten, besonders wenn Sie jüngere Zielgruppen oder Kandidaten im gewerblichen Bereich ansprechen möchten. Eine Social Media Recruiting Agentur nutzt die visuellen Stärken dieser Plattformen, um Ihre Arbeitgebermarke emotional und authentisch zu präsentieren.
                    
                    Auf Instagram können Sie durch Stories, Reels und Feed-Posts einen direkten Einblick in Ihren Arbeitsalltag geben. Zeigen Sie Ihre Unternehmenskultur, stellen Sie Teammitglieder vor und teilen Sie Behind-the-Scenes-Content. Diese Authentizität spricht potenzielle Bewerber an und macht Ihr Unternehmen als Arbeitgeber greifbarer.
                    
                    Facebook bietet umfangreiche Targeting-Möglichkeiten für Recruiting Ads. Sie können nach demografischen Merkmalen, Interessen, Verhaltensweisen und vielem mehr filtern. Auch Facebook-Gruppen sind ein wertvoller Kanal für Social Recruiting – durch die Teilnahme an branchen- oder berufsrelevanten Gruppen können Sie passive Kandidaten erreichen und sich als attraktiver Arbeitgeber positionieren.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Visuelle Storytelling-Formate für emotionales Employer Branding"></Mark>
                  <Mark label="Präzises Targeting für die Ansprache Ihrer idealen Kandidaten"></Mark>
                  <Mark label="Cost-effective Reichweite für Mittelstand und KMU"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Social Media Kampagne starten')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Social Media Kampagne starten</span>
            </div>
          </div>
        </section>
      </section>
      <section className="home-section11">
        <h2 className="home-text12">
          Social Recruiting im Mittelstand: Besondere Herausforderungen und Lösungen
        </h2>
        <div style={{ maxWidth: '1200px', margin: '40px auto', padding: '0 24px' }}>
          <video 
            controls
            autoPlay 
            muted
            loop
            playsInline
            style={{ 
              width: '100%', 
              height: 'auto',
              aspectRatio: '16 / 9',
              borderRadius: '12px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer'
            }}
          >
            <source src="/social-media-recruiting-agentur-berlin.mp4" type="video/mp4" />
            Ihr Browser unterstützt das Video-Tag nicht.
          </video>
        </div>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11" style={{ marginTop: '100px' }}>
                Wie der Mittelstand von Social Recruiting profitiert
              </h2>
              <p className="home-paragraph1">
                <span>
                  Der Mittelstand steht beim Recruiting vor besonderen Herausforderungen: Begrenzte Budgets, weniger Bekanntheit als Großkonzerne und oft spezifische Anforderungen an Fachkräfte. Gleichzeitig bietet der Mittelstand viele Vorteile als Arbeitgeber – flache Hierarchien, vielfältige Aufgaben, kurze Entscheidungswege und oft eine familiäre Unternehmenskultur. Social Recruiting ermöglicht es mittelständischen Unternehmen, diese Stärken gezielt zu kommunizieren und sich im Wettbewerb um Talente zu behaupten.
                </span>
                <br></br>
                <br></br>
                <span>
                  Eine Social Recruiting Agentur versteht die spezifischen Bedürfnisse des Mittelstands. Im Gegensatz zu großen Konzernen, die oft umfangreiche HR-Abteilungen haben, fehlt mittelständischen Unternehmen häufig die Zeit und das Know-how für professionelles Social Media Recruiting. Hier setzt die Zusammenarbeit mit einer Social Recruiting Agentur an: Sie erhalten Zugang zu Expertise, Tools und Best Practices, ohne eine eigene Social-Media-Abteilung aufbauen zu müssen.
                </span>
                <br></br>
                <span>
                  Besonders wichtig im Mittelstand ist ein effizienter Einsatz des Recruiting-Budgets. Social Recruiting bietet hier klare Vorteile: Durch gezieltes Targeting können Sie Ihr Budget fokussiert einsetzen und Streuverluste minimieren. Die Kosten pro qualifizierter Bewerbung sind oft deutlich niedriger als bei traditionellen Recruiting-Kanälen. Zudem ermöglicht Social Media Recruiting eine flexible Skalierung – Sie können mit kleinen Kampagnen starten und diese bei Erfolg ausweiten.
                </span>
                <br></br>
                <span>
                  Ein weiterer Vorteil für den Mittelstand: Social Recruiting ermöglicht es, auch in ländlichen Regionen oder für Nischenpositionen qualifizierte Kandidaten zu finden. Während traditionelle Stellenanzeigen oft nur lokal wirken, erreichen Social Media Kampagnen eine deutschland- oder sogar europaweite Zielgruppe. Eine Social Media Recruiting Agentur kann Sie dabei unterstützen, die Balance zwischen lokaler Verwurzelung und überregionaler Reichweite zu finden.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Mittelstands-Paket')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Mittelstands-Paket anfragen →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Social Recruiting Mittelstand"
              src="/social-media-recruiting-agentur-mittelstand.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>
      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Content-Strategien für erfolgreiches Social Media Recruiting</h2>
          <span className="home-text26">
            Die richtigen Inhalte zur richtigen Zeit auf dem richtigen Kanal – so funktioniert erfolgreiches Social Media Recruiting. Als erfahrene Agentur entwickeln wir Content, der Bewerber begeistert.
          </span>
        </header>
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Content Strategie Recruiting"
              src="/social-media-recruiting-agentur-content.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Content für Social Recruiting</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Von Stellenanzeigen zu Employee Stories: Content, der wirkt
                </h2>
                <p className="section-description">
                  Traditionelle Stellenanzeigen funktionieren auf Social Media nur bedingt. Social Media Recruiting erfordert Content, der unterhält, informiert und inspiriert. Eine Social Media Recruiting Agentur entwickelt Content-Formate, die Ihre Zielgruppe ansprechen und Ihre Arbeitgebermarke stärken. Dabei geht es um mehr als nur das Posten von offenen Stellen – es geht um Storytelling, Authentizität und Mehrwert.
                  
                  Besonders effektiv sind Mitarbeiter-Testimonials: Lassen Sie Ihre Mitarbeiter zu Wort kommen und über ihren Arbeitsalltag, ihre Entwicklungsmöglichkeiten und die Unternehmenskultur sprechen. Dieser authentische Content überzeugt potenzielle Bewerber mehr als jede Hochglanzbroschüre. Video-Content performa auf Social Media besonders gut – kurze Clips, die einen Tag im Unternehmen zeigen, Mitarbeiter-Interviews oder Einblicke in Projekte erzeugen Aufmerksamkeit und Engagement.
                  
                  Auch informative Inhalte sind wichtig: Karrieretipps, Einblicke in Bewerbungsprozesse oder Informationen über Benefits und Entwicklungsmöglichkeiten positionieren Sie als attraktiven Arbeitgeber. Eine Social Recruiting Agentur plant diese Inhalte strategisch und stellt sicher, dass sie zur richtigen Zeit und auf dem richtigen Kanal ausgespielt werden.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Content-Strategie entwickeln')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Content-Strategie entwickeln</span>
            </div>
          </div>
        </section>
        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Social Recruiting Ads"
              src="/social-media-recruiting-agentur-gezielt.png"
              className="home-image22"
              style={{ transform: 'scaleX(-1)' }}
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Recruiting Ads Optimierung
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Wie Social Recruiting Ads qualifizierte Kandidaten ansprechen
                  </h2>
                  <p className="section-description">
                    Recruiting Ads sind das Herzstück vieler Social Recruiting Kampagnen. Im Gegensatz zu organischen Beiträgen ermöglichen Ads ein präzises Targeting und garantierte Reichweite. Eine Social Recruiting Agentur unterstützt Unternehmen dabei, Ads zu erstellen, die nicht nur Aufmerksamkeit erzeugen, sondern auch zu Bewerbungen führen.
                    
                    Erfolgreiches Social Media Recruiting mit Ads beginnt mit der richtigen Zielgruppenansprache. Auf Plattformen wie LinkedIn, Facebook und Instagram können Sie nach demografischen Merkmalen, beruflichen Qualifikationen, Interessen und vielem mehr targeten. Eine professionelle Social Media Recruiting Agentur nutzt diese Möglichkeiten, um Ihre Stellenanzeigen genau denen auszuspielen, die am besten zu Ihrer Position passen.
                    
                    Auch die kreative Gestaltung der Ads ist entscheidend: Aussagekräftige Headlines, ansprechende Visuals und klare Call-to-Actions führen zu höheren Bewerbungsraten. A/B-Testing hilft dabei, die Performance kontinuierlich zu optimieren und herauszufinden, welche Botschaften, Bilder und Targeting-Einstellungen am besten funktionieren. Die Recruiting Agentur unterstützt Unternehmen mit datengetriebenen Insights und kontinuierlicher Optimierung.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Präzises Targeting für maximale Relevanz"></Mark>
                  <Mark label="A/B-Testing und kontinuierliche Optimierung"></Mark>
                  <Mark label="Transparentes Reporting und ROI-Tracking"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Ads-Kampagne starten')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Ads-Kampagne starten</span>
            </div>
          </div>
        </section>
      </section>
      <section className="home-section26">
        <header className="home-header22">
          <span className="section-head">FAQ</span>
          <h2 className="home-heading26 section-heading">
            Häufig gestellte Fragen zu Social Recruiting
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="fa-qroot-class-name"></FAQ>
        </main>
      </section>
      <section className="home-section28">
        <main className="home-content6">
          <header className="home-header23">
            <h2 className="home-heading27 section-heading">
              Bereit für erfolgreiches Social Media Recruiting? Starten Sie jetzt!
            </h2>
            <div className="home-buttons3">
              <div className="home-ios button" onClick={() => openContactModal('Kostenlose Beratung buchen')} style={{ cursor: 'pointer' }}>
                <span className="home-text50">Kostenlose Beratung buchen</span>
              </div>
            </div>
          </header>
          <img
            alt="Social Recruiting Berlin"
            src="/social-media-recruiting-agentur-bereit.png"
            className="home-image25"
          />
        </main>
      </section>
      <Footer activePage="home" />
      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
      
      <div>
        <div className="home-container6">
          <Script
            html={`<script>
    /*
Accordion - Code Embed
*/

(function() {
    // Check if already initialized to prevent duplicate declarations
    if (window._accordionInitialized) return;
    window._accordionInitialized = true;

    /* listenForUrlChangesAccordion() makes sure that if you changes pages inside your app,
    the Accordions will still work*/

    const listenForUrlChangesAccordion = () => {
          let url = location.href;
          document.body.addEventListener(
            "click",
            () => {
              requestAnimationFrame(() => {
                if (url !== location.href) {
                  runAccordionCodeEmbed();
                  url = location.href;
                }
              });
            },
            true
          );
        };


    const runAccordionCodeEmbed = () => {
        const accordionContainers = document.querySelectorAll('[data-role="accordion-container"]'); // All accordion containers
        const accordionContents = document.querySelectorAll('[data-role="accordion-content"]'); // All accordion content
        const accordionIcons = document.querySelectorAll('[data-role="accordion-icon"]'); // All accordion icons

        accordionContents.forEach((accordionContent) => {
            accordionContent.style.display = "none"; //Hides all accordion contents
        });

        accordionContainers.forEach((accordionContainer, index) => {
            accordionContainer.addEventListener("click", () => {
                accordionContents.forEach((accordionContent) => {
                accordionContent.style.display = "none"; //Hides all accordion contents
                });

                accordionIcons.forEach((accordionIcon) => {
                    accordionIcon.style.transform = "rotate(0deg)"; // Resets all icon transforms to 0deg (default)
                });

                accordionContents[index].style.display = "flex"; // Shows accordion content
                accordionIcons[index].style.transform = "rotate(180deg)"; // Rotates accordion icon 180deg
            });
        });
    }

    runAccordionCodeEmbed()
    listenForUrlChangesAccordion()
})();

/*
Here's what the above is doing:
    1. Selects all accordion containers, contents, and icons
    2. Hides all accordion contents
    3. Adds an event listener to each accordion container
    4. When an accordion container is clicked, it:
        - Hides all accordion contents
        - Resets all icon transforms to 0deg (default)
        - Checks if this container has class "accordion-open"
            - If it does, it removes class "accordion-open"
            - If it doesn't, it:
                - Removes class "accordion-open" from all containers
                - Adds class "accordion-open" to this container
                - Shows accordion content
                - Rotates accordion icon 180deg
*/
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Home
